// client/src/pages/marketing/NieuwsbriefPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/marketing/Navbar';
import Hero from '../../components/marketing/Hero';
import Footer from '../../components/marketing/Footer';
import { getPublishedPosts } from '../../data/nieuwsbrief';

const NieuwsbriefPage = () => {
  const posts = getPublishedPosts();

  return (
    <div className="min-h-screen bg-cream-100 text-charcoal-800 font-['Lexend_Deca'] text-base leading-relaxed">
      <Navbar />
      
      <Hero
        title="Nieuws & Updates"
        subtitle="Blijf op de hoogte van nieuwe ontwikkelingen, tips en trainingen"
        height="normal"
      />

      <main className="container mx-auto max-w-4xl py-20 px-5 mt-[70px]">
        {posts.length === 0 ? (
          // Empty state
          <div className="text-center py-20">
            <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
            </svg>
            <h2 className="text-xl text-gray-600 mb-2">Nog geen nieuwsberichten</h2>
            <p className="text-gray-500">Check later voor nieuwe updates!</p>
          </div>
        ) : (
          // Posts list
          <div className="space-y-12">
            {posts.map((post) => (
              <article 
                key={post.id}
                className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                {post.imageUrl && (
                  <img 
                    src={post.imageUrl} 
                    alt={post.title}
                    className="w-full h-64 object-cover"
                  />
                )}
                
                <div className="p-8">
                  {/* Post metadata */}
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <time dateTime={post.date}>
                      {new Date(post.date).toLocaleDateString('nl-NL', { 
                        year: 'numeric', 
                        month: 'long', 
                        day: 'numeric' 
                      })}
                    </time>
                    
                    {post.author && (
                      <>
                        <span className="mx-2">•</span>
                        <span>{post.author}</span>
                      </>
                    )}
                    
                    {post.category && (
                      <>
                        <span className="mx-2">•</span>
                        <span className="inline-block px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium">
                          {post.category}
                        </span>
                      </>
                    )}
                  </div>

                  {/* Post title */}
                  <h2 className="text-2xl font-['Lexend_Deca'] text-gray-800 mb-4 hover:text-purple-600 transition-colors">
                    <Link to={`/nieuwsbrief/${post.slug}`}>
                      {post.title}
                    </Link>
                  </h2>

                  {/* Post excerpt */}
                  <p className="text-gray-700 leading-relaxed mb-4">
                    {post.excerpt}
                  </p>

                  {/* Read more link */}
                  {post.content && post.content !== post.excerpt && (
                    <Link 
                      to={`/nieuwsbrief/${post.slug}`}
                      className="inline-flex items-center text-purple-600 hover:text-purple-800 font-medium transition-colors"
                    >
                      Lees meer
                      <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </Link>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default NieuwsbriefPage;